import { render, staticRenderFns } from "./FormMutate.vue?vue&type=template&id=1a492674&"
import script from "./FormMutate.vue?vue&type=script&lang=ts&"
export * from "./FormMutate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a492674')) {
      api.createRecord('1a492674', component.options)
    } else {
      api.reload('1a492674', component.options)
    }
    module.hot.accept("./FormMutate.vue?vue&type=template&id=1a492674&", function () {
      api.rerender('1a492674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TruckingSalesOrder/FormMutate.vue"
export default component.exports